export const CornerArrowIcon = props => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M3.33334 9.33296L3.33325 3.33303L4.66659 3.33301L4.66665 7.99963L11.4479 7.99969L8.81475 5.36652L9.75755 4.42371L14.0001 8.66636L9.75755 12.909L8.81475 11.9662L11.4479 9.33303L3.33334 9.33296Z'
      fill='#9E9E9E'
    />
  </svg>
);
